import React from "react";
import loadable from "@loadable/component";

const Header = loadable(() =>
	import("@components/Dashboard/Pro/Funnel/Shared/Header")
);

export default ({ children, ...props }) => (
	<React.Fragment>
		<Header label={"All done!"} {...props} />
		{children}
	</React.Fragment>
);
